import axios from '@axios'

export default {
    namespaced: true,
    state: {
        LoteR: [],
        maq: [],
        tallas: [],
        importadores: [],
        marcas: [],
        tipoP: [],
        tipoC: [],
        supervisores: [],
        proveedores: [],
        registrosINP: [],
        reportesRC08: [],
        proveedor: [],
        inp: [],
        proveedorlote: [],
        consultas: [],
        lotexfecha: [],
        lotexfechaA: [],
        reportesProcesofresco: [],
        reportesProductoTerminado: [],
        reporteProcesoFrescoAuditoria: [],
        //reportesProcesofrescofile: [],
        reporteHidratante: [],
        // Crear usuario
        directorios: [],
        archivo: [],
        correcciones: [],
        // SALMUERA
        salmuera: [],
        monitoresSalmuera: [],
        monitoresClasificacionCamaronEntero: [],
        monitoresProcesoEntero: [],
        // SALMUERA
        cocido: [],
        // ETIQUETADO
        controlEtiquetas: [],
        controlEtiquetasAuditoria: [],
        cargosSupervisores: [],
        // ETIQUETADO
        gsxfecha: [],
        gsalmuera: [],
        jefeCalidad: {},
        areas: [],
        // DETECTOR DE METALES
        cargosSupervisoresCamara: [],
        cargosJefesPlanta: [],
        controlMetalesPT: [],
        controlMetalesPTAuditoria: [],
        // DETECTOR DE METALES
        // equipos_maquinas
        maquina: [],
        cabiplant: [],
        campiscs: [],
        piscinas: [],
        reporteAnalisisFisicoQuimico: [],
        reporteAnalisisFisicoQuimicoAuditoria: [],
        reporteCocido: [],
        reporteCocidoAuditoria: [],
        reporteTemperatura: [],
        reporteTemperaturaAuditoria: [],
        productoTerminado: {
            // Namespace de producto terminado
            productos: [],
        },
        // EMPAQUE
        reporteEmpaquePT: [],
        reporteEmpaquePTAuditoria: [],
        empaques: [],
        masters: [],
        reportesProductoTerminadoAuditoria: [],
    },

    getters: {
        getMaquinas(state) {
            return state.maq
        },
        getTallas(state) {
            return state.tallas
        },
        getImportadores(state) {
            return state.importadores
        },
        getMarcas(state) {
            return state.marcas
        },
        getSupervisores(state) {
            return state.supervisores
        },
        getProveedores(state) {
            return state.proveedores
        },
        getINP(state) {
            return state.inp
        },
        getRegistroINP(state) {
            return state.registrosINP
        },
        getReportesRC08(state) {
            return state.reportesRC08
        },
        getProveedor(state) {
            return state.proveedor
        },

        getConsultaProcesoFresco(state) {
            return state.consultas
        },
        getlotexfecha(state) {
            return state.lotexfecha
        },
        getlotexfechaA(state) {
            return state.lotexfechaA
        },
        // RCCC08/RCCC23
        getreportesProcesofresco(state) {
            return state.reportesProcesofresco
        },
        getReporteProcesoFrescoAuditoria(state) {
            return state.reporteProcesoFrescoAuditoria
        },

        getreportesProductoTerminado(state) {
            return state.reportesProductoTerminado
        },

        getReporteHidratante(state) {
            return state.reporteHidratante
        },

        // Crear usuario
        getDirectorios(state) {
            return state.directorios
        },
        getArchivo(state) {
            return state.archivo
        },
        getGuiaSalidaCamara(state) {
            return state.guiaSalidaCamara
        },
        getControlTemperaturaCamara(state) {
            return state.controlTemperaturaCamara
        },
        getLoteR(state) {
            return state.loteR
        },
        getTipoP(state) {
            return state.tipoP
        },
        getCorrecciones(state) {
            return state.correcciones
        },
        // SALMUERA
        getSalmuera(state) {
            return state.salmuera
        },
        getMonitoresSalmuera(state) {
            return state.monitoresSalmuera
        },
        getMonitoresClasificacionCamaronEntero(state) {
            return state.monitoresClasificacionCamaronEntero
        },
        getMonitoresProcesoEntero(state) {
            return state.monitoresProcesoEntero
        },
        // SALMUERA
        getFiltroCocido(state) {
            return state.lotexfecha
        },
        getReporteCocido(state) {
            return state.cocido
        },
        // ETIQUETADO
        getCargosSupervisores(state) {
            return state.cargosSupervisores
        },
        getReporteControlEtiquetas(state) {
            return state.controlEtiquetas
        },
        getReporteControlEtiquetasAuditoria(state) {
            return state.controlEtiquetasAuditoria
        },
        // ETIQUETADO
        getFiltroGS(state) {
            return state.gsxfecha
        },
        getReporteGS(state) {
            return state.gsalmuera
        },
        getCargoC(state) {
            return state.tipoC
        },
        // DETECTOR DE METALES
        getCargosSupervisoresCamara(state) {
            return state.cargosSupervisoresCamara
        },
        getCargosJefesPlanta(state) {
            return state.cargosJefesPlanta
        },
        getReporteControlMetalesPT(state) {
            return state.controlMetalesPT
        },
        getReporteControlMetalesPTAuditoria(state) {
            return state.controlMetalesPTAuditoria
        },
        // DETECTOR DE METALES
        getJefeCalidad(state) {
            return state.jefeCalidad
        },
        getAreas(state) {
            return state.areas
        },
        // equipos maquina
        getEquipoM(state) {
            return state.maquina
        },
        getEquipoC(state) {
            return state.cabiplant
        },
        getCamPiscs(state) {
            return state.campiscs
        },
        getPiscinas(state) {
            return state.piscinas
        },

        getReporteAnalisisFisicoQuimico(state) {
            return state.reporteAnalisisFisicoQuimico
        },
        getReporteAnalisisFisicoQuimicoAuditoria(state) {
            return state.reporteAnalisisFisicoQuimicoAuditoria
        },
        getReporteEmpaquePT(state) {
            return state.reporteEmpaquePT
        },
        getRegistroEmpaquePTAuditoria(state) {
            return state.reporteEmpaquePTAuditoria
        },

        getEmpaque(state) {
            return state.empaques
        },
        getMaster(state) {
            return state.masters
        },
        getreportesProductoTerminadoAuditoria(state) {
            return state.reportesProductoTerminadoAuditoria
        },
    },

    mutations: {
        // tonny
        setLoteR(state, LoteR) {
            state.LoteR = LoteR
        },
        setTipoPresentacion(state, tipoP) {
            state.tipoP = tipoP
        },
        setTipoCargo(state, tipoC) {
            state.tipoC = tipoC
        },
        setReportesControlTemperaturaCamara(state, controlTemperaturaCamara) {
            state.controlTemperaturaCamara = controlTemperaturaCamara
        },
        setReportesControlTemperaturaBin(state, controlTemperaturaBin) {
            state.controlTemperaturaBin = controlTemperaturaBin
        },
        setReportesControlDescongeladoVa(state, controlDescongeladoVa) {
            state.controlDescongeladoVa = controlDescongeladoVa
        },
        setReportesControlCamaronCocido(state, controlCamaronCocido) {
            state.controlCamaronCocido = controlCamaronCocido
        },
        setReportesControlBinesSobrante(state, controlBinesSobrante) {
            state.controlBinesSobrante = controlBinesSobrante
        },
        setReportesControlAreaIqf(state, controlAreaIqf) {
            state.controlAreaIqf = controlAreaIqf
        },
        setReportesControlNave4(state, controlNave4) {
            state.controlNave4 = controlNave4
        },
        setReportesControlNave2(state, controlNave2) {
            state.controlNave2 = controlNave2
        },
        setReportesControlNave3(state, controlNave2) {
            state.controlNave3 = controlNave2
        },
        setReportesControlSalmuera(state, controlSalmuera) {
            state.controlSalmuera = controlSalmuera
        },
        setReportesGuiaSalidaCamara(state, guiaSalidaCamara) {
            state.guiaSalidaCamara = guiaSalidaCamara
        },
        setMaquinas(state, maq) {
            state.maq = maq
        },
        setTallas(state, tallas) {
            state.tallas = tallas
        },
        setImportadores(state, importadores) {
            state.importadores = importadores
        },
        setMarcas(state, marcas) {
            state.marcas = marcas
        },
        setRegistrosINP(state, registrosINP) {
            state.registrosINP = registrosINP
        },
        setReportesRC08(state, reportesRC08) {
            state.reportesRC08 = reportesRC08
        },
        setProveedores(state, proveedores) {
            state.proveedores = proveedores
        },
        setINP(state, inp) {
            state.inp = inp
        },
        setProveedor(state, prov) {
            state.proveedor = prov
        },

        setConsultaProcesoFresco(state, consultas) {
            state.consultas = consultas
        },
        setlotexfecha(state, lotexfecha) {
            state.lotexfecha = lotexfecha
        },
        setlotexfechaA(state, lotexfechaA) {
            state.lotexfechaA = lotexfechaA
        },
        // RCCC08/RCCC23
        setreportesProcesofresco(state, reportesProcesofresco) {
            state.reportesProcesofresco = reportesProcesofresco
        },
        setReporteProcesoFrescoAuditoria(state, reporteProcesoFrescoAuditoria) {
            state.reporteProcesoFrescoAuditoria = reporteProcesoFrescoAuditoria
        },

        setreportesProductoTerminado(state, reportesProductoTerminado) {
            state.reportesProductoTerminado = reportesProductoTerminado
        },

        setReporteHidratante(state, reporteHidratante) {
            state.reporteHidratante = reporteHidratante
        },
        // Crear Usuario
        setDirectorios(state, directorios) {
            state.directorios = directorios
        },
        setArchivo(state, archivo) {
            state.archivo = archivo
        },
        setCorrecciones(state, correcciones) {
            state.correcciones = correcciones
        },
        // SALMUERA
        setDescongeladoSalmuera(state, salmuera) {
            state.salmuera = salmuera
        },
        setMonitoresSalmuera(state, monitores) {
            state.monitoresSalmuera = monitores
        },
        setMonitoresClasificacionCamaronEntero(state, monitores) {
            state.monitoresClasificacionCamaronEntero = monitores
        },
        setMonitoresProcesoEntero(state, monitores) {
            state.monitoresProcesoEntero = monitores
        },
        // SALMUERA
        setFiltroCocido(state, lotexfecha) {
            state.lotexfecha = lotexfecha
        },
        setSupervisores(state, sup) {
            state.supervisores = sup
        },
        // ETIQUETADO
        setCargosSupervisores(state, sup) {
            state.cargosSupervisores = sup
        },
        setReporteControlEtiquetas(state, controlEtiquetas) {
            state.controlEtiquetas = controlEtiquetas
        },
        setReporteControlEtiquetasAuditoria(state, controlEtiquetasAuditoria) {
            state.controlEtiquetasAuditoria = controlEtiquetasAuditoria
        },
        // ETIQUETADO
        setFiltroGS(state, gsxfecha) {
            state.gsxfecha = gsxfecha
        },
        setReporteGS(state, gsalmuera) {
            state.gsalmuera = gsalmuera
        },
        // DETECTOR DE METALES
        setCargosSupervisoresCamara(state, sup) {
            state.cargosSupervisoresCamara = sup
        },
        setCargosJefesPlanta(state, sup) {
            state.cargosJefesPlanta = sup
        },
        setReporteControlMetalesPT(state, controlMetalesPT) {
            state.controlMetalesPT = controlMetalesPT
        },
        setReporteControlMetalesPTAuditoria(state, controlMetalesPTAuditoria) {
            state.controlMetalesPTAuditoria = controlMetalesPTAuditoria
        },
        // DETECTOR DE METALES
        setJefeCalidad(state, jefeCalidad) {
            state.jefeCalidad = jefeCalidad
        },
        setAreas(state, areas) {
            state.areas = areas
        },
        setEquipoM(state, maquina) {
            state.maquina = maquina
        },
        setEquipoC(state, cabiplant) {
            state.cabiplant = cabiplant
        },
        setCamPiscs(state, cps) {
            state.campiscs = cps
        },
        setPiscinas(state, piscinas) {
            state.piscinas = piscinas
        },

        setReporteAnalisisFisicoQuimico(state, reporteAnalisisFisicoQuimico) {
            state.reporteAnalisisFisicoQuimico = reporteAnalisisFisicoQuimico
        },
        setReporteAnalisisFisicoQuimicoAuditoria(state, reporteAnalisisFisicoQuimicoAuditoria) {
            state.reporteAnalisisFisicoQuimicoAuditoria = reporteAnalisisFisicoQuimicoAuditoria
        },
        setReporteCocido(state, reporteCocido) {
            state.reporteCocido = reporteCocido
        },
        setReporteCocidoAuditoria(state, reporteCocidoAuditoria) {
            state.reporteCocidoAuditoria = reporteCocidoAuditoria
        },

        setReporteTemperatura(state, reporteTemperaturaAuditoria) {
            state.reporteTemperatura = reporteTemperaturaAuditoria
        },

        setRegistroEmpaquePT(state, datos) {
            state.reporteEmpaquePT = datos
        },
        setRegistroEmpaquePTAuditoria(state, datos) {
            state.reporteEmpaquePTAuditoria = datos
        },

        setEmpaque(state, empaques) {
            state.empaques = empaques
        },
        setMaster(state, masters) {
            state.masters = masters
        },
        setreportesProductoTerminadoAuditoria(state, reportesProductoTerminadoAuditoria) {
            state.reportesProductoTerminadoAuditoria = reportesProductoTerminadoAuditoria
        },
    },

    actions: {
        // Get params
        fetchMaquinas({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/maquinas')
                    .then(response => {
                        commit('setMaquinas', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchEquipoM({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/EquipoM')
                    .then(response => {
                        commit('setEquipoM', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchEquipoC({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/EquipoC')
                    .then(response => {
                        commit('setEquipoC', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchTallas({ commit }, tipo) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/controlCalidad/tallas/${tipo}`)
                    .then(response => {
                        commit('setTallas', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchImportadores({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/importadores')
                    .then(response => {
                        commit('setImportadores', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchMarcas({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/marcas')
                    .then(response => {
                        commit('setMarcas', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchTiposPresentacion({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/tipo')
                    .then(response => {
                        commit('setTipoPresentacion', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchCargosCalidad({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/cargo', { params: data })
                    .then(response => {
                        commit('setTipoCargo', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchProveedores({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/controlCalidad/obtainProv/${data}`)
                    .then(response => {
                        commit('setProveedor', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchGramosPromedioCE(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/gramosPromedioCE', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchSupervisores({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/supervisores')
                    .then(response => {
                        commit('setSupervisores', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchProveedoresList({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/proveedores')
                    .then(response => {
                        commit('setProveedores', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        getAllINPFromInspeccionPreeliminar({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/v2/control-calidad/materia-prima/rc-mp-01/inp-list', { params: data })
                    .then(response => {
                        commit('setINP', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchLotesCE(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/lotesCE', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchObtainRegistroINP({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/obtainINP', { params: data })
                    .then(response => {
                        commit('setRegistrosINP', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchPiscinas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/obtainPiscinas', { params: data })
                    .then(response => {
                        commit('setPiscinas', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchReportesRC08({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/reportesRC08', { params: data })
                    .then(response => {
                        commit('setReportesRC08', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchLoteXFecha({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/lotexfecha', data)
                    .then(response => {
                        commit('setlotexfecha', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchLoteXFechaAuditoria({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/lotexfechaAuditoria', data)
                    .then(response => {
                        commit('setlotexfechaA', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        // Consulta de procesos
        fetchConsultaProcesoFresco({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/consultaProcesoFresco', data)
                    .then(response => {
                        commit('setConsultaProcesoFresco', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchFiltroCocido({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/filtroUsuarioXFecha', { params: data })
                    .then(response => {
                        commit('setFiltroCocido', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        async crearCartaGarantiaPesca(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/materia-prima/carta-garantia-pesca', data)
            return res.data
        },

        async crearControlSanFelipe(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/materia-prima/san-felipe', data)
            return res.data
        },

        async getMonitoresSalmuera(_a, data) {
            return await axios.get('/api/auth/controlCalidad/materia-prima/salmuera/monitores', {
                params: {
                    ...data,
                },
            })
        },

        // TODO: Eliminar
        async consultarCartaGarantiaPesca(_a, data) {
            return await axios.get('/api/auth/controlCalidad/materia-prima/carta-garantia-pesca', {
                params: data,
            })
        },

        async consultarSanFelipe(_a, data) {
            return await axios.get('/api/auth/controlCalidad/materia-prima/san-felipe', {
                params: data,
            })
        },

        consultarMateriaPrimaAuditoria(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/ConsultaMateriaPrimaAuditoria', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        consultarProcesoCola(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/ConsultaProcesoCola', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        consultarProcesoColaAuditoria(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/ConsultaProcesoColaAuditoria', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        modificacionMateriaPrima(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/ModificacionMateriaPrima', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        modificacionMateriaPrimaAuditoria(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/ModificacionMateriaPrimaAuditoria', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        async fetchGuardarControlAguaGlaseo(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/glaseo/control-agua-glaseo', data)
            return res.data
        },

        fetchAguaGlaseoxFecha(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/AguaGlaseo', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchAguaGlaseoxFechaAuditoria(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/fechaGlaseoAuditoria', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchGuardarGlaseo(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/updateGlaseo', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchRegistrarGlaseoAuditoria(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/AguaGlaseoAuditoria', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchValidarCabinplant(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(
                        `/api/auth/controlCalidad/validCabinplant/${
                            // window.atob(data)
                            data
                        }`
                    )
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        async fetchGuardarControlGlaseoSalmuera(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/glaseo/control-salmuera', data)
            return res.data
        },

        fetchFiltroGlaseoSalmuera({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/usuariosXFecha', { params: data })
                    .then(response => {
                        commit('setFiltroGS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchReporteGlaseoSalmuera({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/reporteGlaseoSalmuera', { params: data })
                    .then(response => {
                        commit('setReporteGS', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchGlaseoSalmueraxFechaAuditoria(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/fechaGlaseoSalmueraAuditoria', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchGuardarGlaseoSalmuera(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/updateGlaseoSalmuera', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchRegistrarGlaseoSalmueraAuditoria(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/GlaseoSalmueraAuditoria', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchMonitoresClasificacionCamaronEntero({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/proceso-entero/consultaClasificacionCamaronEnteroMonitores', {
                        params: data,
                    })
                    .then(response => {
                        commit('setMonitoresClasificacionCamaronEntero', response.data)
                        resolve(response.data)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        // SALMUERA
        /*fetchRegistroLiberacionCocido({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        '/api/auth/controlCalidad/GuardarLiberacionCocido',
                        data,
                    )
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        fetchRegistroDesinfeccion({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        '/api/auth/controlCalidad/GuardarDesinfeccionInstrumento',
                        data,
                    )
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        fetchRegistroCamaronCocido({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        '/api/auth/controlCalidad/GuardarCamaronCocido',
                        data,
                    )
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        fetchRegistroProcesoSanFelipe({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        "/api/auth/controlCalidad/ProcesoSanFelipe",
                        data
                    )
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },*/
        // ETIQUETADO: CONTROL ETIQUETAS
        fetchCargosSupervisores({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/cargosSupervisores')
                    .then(response => {
                        commit('setCargosSupervisores', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        // fetchRegistroControlEtiquetas({ commit }, data) {
        //     return new Promise((resolve, reject) => {
        //         axios
        //             .post('/api/auth/controlCalidad/GuardarControlEtiquetas', data)
        //             .then(response => {
        //                 resolve(response)
        //             })
        //             .catch(error => {
        //                 reject(error)
        //             })
        //     })
        // },
        fetchReporteControlEtiquetas({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/reporteControlEtiquetas', { params: data })
                    .then(response => {
                        commit('setReporteControlEtiquetas', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        editarRegistroControlEtiquetas(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/editarRegistroControlEtiquetas', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchReporteControlEtiquetasAuditoria({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/reporteControlEtiquetasAuditoria', { params: data })
                    .then(response => {
                        commit('setReporteControlEtiquetasAuditoria', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        editarControlEtiquetasAuditoria(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/editarControlEtiquetasAuditoria', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        getAllMongo(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/ETIQUETADO/getAllMongo', { params: data })
                    .then(response => {
                        // commit("set", response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        // ETIQUETADO: CONTROL ETIQUETAS
        // Modificacion de Procesos
        /*fetchModificarGarantiaPesca({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        '/api/auth/controlCalidad/ModificarGarantiaPesca',
                        data,
                    )
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },*/

        fetchModificarProcesoCola(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/modificarProcesoCola', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchModificarProcesoColaAuditoria(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/modificarProcesoColaAuditoria', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchCamPiscs({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/piscinasC')
                    .then(response => {
                        commit('setCamPiscs', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        /*fetchModificarInspeccionPreliminar({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        '/api/auth/controlCalidad/ModificarInspeccionPreliminar',
                        data,
                    )
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },*/

        editarRegistro(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/editar', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        editarCocido(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/editarCocido', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        editarCocidoAuditoria(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/editarCocidoAuditoria', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        verificarCorreccion(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/verificarCorreccion', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        // Reportes de procesos
        fetchReporteProcesoFresco({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/reporteProcesoFresco', data)
                    .then(response => {
                        commit('setreportesProcesofresco', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        /*fetchModificarControlProcesoSanFelipe({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post("/api/auth/controlCalidad/ModificarControlProcesoSanFelipe", data)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                        console.error(error);
                    });
            });
        },*/

        //Reportes de procesos
        /*fetchReporteProcesoFrescoFile({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        '/api/auth/controlCalidad/reporteProcesoFrescofile',
                        data,
                    )
                    .then(response => {
                        commit('setreportesProcesofrescofile', response.data);
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                        console.error(error);
                    });
            });
        },*/

        fetchCorrecciones({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/getCorrecciones', { params: data })
                    .then(response => {
                        commit('setCorrecciones', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        registrarCocido(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/RegistroCocido', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchReporteCocido({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/reporteCocido', { params: data })
                    .then(response => {
                        commit('setReporteCocido', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchReporteCocidoAuditoria(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/reporteCocidoAuditoria', { params: data })
                    .then(response => {
                        // commit("setReporteCocido", response.data);
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        //tonny
        fechtRegistroControlSalmuera(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/GuardarControlSalmuera', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fecthRegistroControlNave4(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/GuardarControlNave4', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchRegistroControlBinesSobrante(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/GuardarControlSalmuera', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRegistroControlCamaronCocido(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/GuardarControlCamaronCocido', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchRegistroControlDescongeladoVa(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/GuardarControlDescongeladoVa', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRegistroControlTempBin(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/GuardarControlTempBin', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRegistroControlTempCama(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/GuardarGuiaControlTemp', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchModificaciónGeneralTemperatura(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/ModificaciónGeneralTemperatura', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fechtReporteControlSalmuera({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/reportesControlSalmuera', { params: data })
                    .then(response => {
                        commit('setReportesControlSalmuera', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fechtReporteControlNave4({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/reportesControlNave4', { params: data })
                    .then(response => {
                        commit('setReportesControlNave4', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fechtReporteControlNave2({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/reportesControlNave2', { params: data })
                    .then(response => {
                        commit('setReportesControlNave2', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fechtReporteControlNave3({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/reportesControlNave3', { params: data })
                    .then(response => {
                        commit('setReportesControlNave3', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchReporteControlAreaIqf({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/reportesControlAreaIqf', { params: data })
                    .then(response => {
                        commit('setReportesControlAreaIqf', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchReporteControlBinesSobrante({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/reportesControlBinesSobrante', { params: data })
                    .then(response => {
                        commit('setReportesControlBinesSobrante', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchReporteControlCamaronCocido({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/reportesControlBinesSobrante', { params: data })
                    .then(response => {
                        commit('setReportesControlBinesSobrante', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchReporteControlDescongeladoVa({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/reportesControlDescongeladoVa', { params: data })
                    .then(response => {
                        commit('setReportesControlDescongeladoVa', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchReporteControlTemperaturaBin({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/reportesControlTemperaturaBin', { params: data })
                    .then(response => {
                        commit('setReportesControlTemperaturaBin', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchReporteControlTemperaturaCamara({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/reportesControlTemperaturaCamara', { params: data })
                    .then(response => {
                        commit('setReportesControlTemperaturaCamara', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchReporteGuiaSalidaCamara({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/reportesGuiaSalidaCamara', { params: data })
                    .then(response => {
                        commit('setReportesGuiaSalidaCamara', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchRegistroGuiaProdCama(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/GuardarGuiaProdCamara', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchLoteR({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/controlCalidad/obtainLoteR/${data}`)
                    .then(response => {
                        commit('setLoteR', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchValidarLoteVRF(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/controlCalidad/Lote/${data}`)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        // Crear Usuario
        crearSupervisor(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/crearSupervisor', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchDirectorios({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/directorios', { params: data })
                    .then(response => {
                        commit('setDirectorios', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchArchivo({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'post',
                    url: '/api/auth/controlCalidad/archivo',
                    responseType: 'blob',
                    data,
                })
                    .then(response => {
                        commit('setArchivo', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchModificaciónGeneralAnalisis(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/ModificaciónGeneralAnalisis', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchModificacionGeneralAnalisisAuditoria(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/ModificacionGeneralAnalisisAuditoria', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fecthConsultarReporteValorAgregado({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/ConsultarReporteValorAgregado', { params: data })
                    .then(response => {
                        commit('setReporteHidratante', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchGuardarValorAgregado(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/GuardarReporteValorAgregado', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        modificarValorAgregadoAuditoria(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/ModificarValorAgregadoAuditoria', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // DETECTOR DE METALES: RCCC161
        fetchCargosSupervisoresCamara({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/detectorDeMetales/cargosSupervisoresCamara')
                    .then(response => {
                        commit('setCargosSupervisoresCamara', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchCargosJefesPlanta({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/detectorDeMetales/cargosJefesPlanta')
                    .then(response => {
                        commit('setCargosJefesPlanta', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        async registroControlMetalesPT(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/detector-metales/metales-pt', data)
            return res.data
        },

        async consultarMetalesPTByLote(_a, data) {
            const res = await axios.get(`/api/auth/controlCalidad/detector-metales/metales-pt-lote/${data}`)
            return res.data[0]
        },

        fetchReporteControlMetalesPT({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/detectorDeMetales/reporteControlMetalesPT', { params: data })
                    .then(response => {
                        commit('setReporteControlMetalesPT', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        editarRegistroControlMetalesPT(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/detectorDeMetales/editarRegistroControlMetalesPT', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchReporteControlMetalesPTAuditoria({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/detectorDeMetales/reporteControlMetalesPTAuditoria', {
                        params: data,
                    })
                    .then(response => {
                        commit('setReporteControlMetalesPTAuditoria', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        editarControlMetalesPTAuditoria(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/detectorDeMetales/editarControlMetalesPTAuditoria', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        // DETECTOR DE METALES: RCCC161
        fetchJefeCalidad({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/jefeCalidad')
                    .then(response => {
                        commit('setJefeCalidad', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        consultarAnalisisFisicoQuimico({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/ConsultaAnalisisFisicoQuimico', { params: data })
                    .then(response => {
                        commit('setReporteAnalisisFisicoQuimico', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        consultarAnalisisFisicoQuimicoAuditoria({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/ConsultaAnalisisFisicoQuimicoAuditoria', { params: data })
                    .then(response => {
                        commit('setReporteAnalisisFisicoQuimicoAuditoria', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        editarAnalisisFisicoQuimicoAuditoria(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/EditarAnalisisFisicoQuimicoAuditoria', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchAreas({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/areas')
                    .then(response => {
                        commit('setAreas', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        async registroResidualMetabisulfito(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/fisico-quimico/residual-metabisulfito', data)
            return res.data
        },

        async actualizarResidualMetabisulfito(_a, data) {
            const res = await axios.post(
                '/api/auth/controlCalidad/fisico-quimico/residual-metabisulfito/actualizar',
                data
            )
            return res.data
        },

        async registroMonierWillian(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/fisico-quimico/monier-willian', data)
            return res.data
        },

        async actualizarMonierWillian(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/fisico-quimico/monier-willian/actualizar', data)
            return res.data
        },

        async registroRecepcionGaveta(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/fisico-quimico/recepcion-gaveta', data)
            return res.data
        },

        async actualizarRecepcionGaveta(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/fisico-quimico/recepcion-gaveta/actualizar', data)
            return res.data
        },

        async registroBancoMuestra(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/fisico-quimico/banco-muestra', data)
            return res.data
        },

        async actualizarBancoMuestra(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/fisico-quimico/banco-muestra/actualizar', data)
            return res.data
        },

        async consultarResistenciaMelanosis({ commit }) {
            const res = await axios.get('/api/auth/controlCalidad/fisico-quimico/resistencia-melanosis')
            commit('setReporteAnalisisFisicoQuimico', res.data)
            return res
        },

        async consultarResistenciaMelanosisCarga({ commit }, data) {
            const res = await axios.get('/api/auth/controlCalidad/fisico-quimico/resistencia-melanosis/carga', {
                params: data,
            })
            commit('setReporteAnalisisFisicoQuimico', res.data)
            return res
        },

        async registroResistenciaMelanosis(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/fisico-quimico/resistencia-melanosis', data)
            return res.data
        },

        async actualizarResistenciaMelanosis(_a, data) {
            const res = await axios.post(
                '/api/auth/controlCalidad/fisico-quimico/resistencia-melanosis/actualizar',
                data
            )
            return res.data
        },

        //COCIDO

        async consultarLiberacionCocido({ commit }) {
            const res = await axios.get('/api/auth/controlCalidad/cocido/liberacion-cocido')
            commit('setReporteCocido', res.data)
            return res.data
        },

        async registroLiberacionCocido(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/cocido/liberacion-cocido', data)
            return res.data
        },

        async consultarProcesoCocido({ commit }) {
            const res = await axios.get('/api/auth/controlCalidad/cocido/proceso-cocido')
            commit('setReporteCocido', res.data)
            return res.data
        },

        async consultarProcesoCocidoCarga({ commit }, data) {
            const res = await axios.get('/api/auth/controlCalidad/cocido/proceso-cocido/carga', {
                params: data,
            })
            commit('setReporteCocido', res.data)
            return res
        },

        async registroProcesoCocido(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/cocido/proceso-cocido', data)
            return res.data
        },

        async actualizarProcesoCocido(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/cocido/proceso-cocidor', data)
            return res.data
        },

        async registroDesinfeccionInstrumentos(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/cocido/desinfeccion-instrumentos', data)
            return res.data
        },

        //Valor agregado

        // Se movio al @stores/controlCalidad/valorAgregado/RCCC103/peladoFrescoStore.ts
        // async registroPeladoFresco(_a, data) {
        //     return await axios.post('/api/auth/v2/control-calidad/valor-agregado/rc-cc-103', data)
        // },

        async registroInspeccionSabor(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/valor-agregado/inspeccion-sabor', data)
            return res.data
        },

        async registroConsumoHidratante(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/valor-agregado/consumo-hidratante', data)
            return res.data
        },

        //Temperatura

        async registroTemperaturaCamara(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/temperatura/temperatura-camara', data)
            return res.data
        },

        async registroGuiaSalidaDescongelado(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/temperatura/guia-salida-descongelado', data)
            return res.data
        },

        async registroDescongeladoValorAgregado(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/temperatura/descongelado-valor-agregado', data)
            return res.data
        },

        async registroTemperaturaCamaronCocido(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/temperatura/camaron-cocido', data)
            return res.data
        },

        async registroTemperaturaBines(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/temperatura/temperatura-bines', data)
            return res.data
        },

        async consultarTemperaturaBinesCarga({ commit }, data) {
            const res = await axios.get('/api/auth/controlCalidad/temperatura/temperatura-bines/carga', {
                params: data,
            })
            commit('setReporteTemperatura', res.data)
            return res
        },

        async registroTemperaturaBinesDetalle(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/temperatura/temperatura-bines/detalle', data)
            return res.data
        },

        async registroBinesSobrantes(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/temperatura/bines-sobrantes', data)
            return res.data
        },

        async registroTempAreaIQF(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/temperatura/area-iqf', data)
            return res.data
        },

        async registroAmbienteNave4(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/temperatura/ambiente-nave4', data)
            return res.data
        },

        async registroAmbienteSalmuera(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/temperatura/ambiente-salmuera', data)
            return res.data
        },

        async registroAmbienteNave2(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/temperatura/ambiente-nave2', data)
            return res.data
        },

        async registroAmbienteNave3(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/temperatura/ambiente-nave3', data)
            return res.data
        },

        //Etiquetado

        async registroControlEtiqueta(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/etiquetado/control-etiqueta', data)
            return res.data
        },

        async consultarEtiquetadoPTByLote(_a, data) {
            const res = await axios.get(`/api/auth/controlCalidad/etiquetado/etiquetado-lote/${data}`)
            return res.data[0]
        },

        //Foto

        async registroFoto(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/fotos', data)
            return res.data
        },

        registroAnalisisFisicoQuimico(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/RegistroAnalisisFisicoQuimico', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        async registroProcesoEntero(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/proceso-entero/clasificacion-camaron-entero', data)

            // TODO: Check if this is really necessary...
            // commit('setreportesProcesofresco', resData.data)

            return res.data
        },

        async consultarClasificacionCamaronEnteroPendientes(_a, data) {
            const res = await axios.get(
                '/api/auth/controlCalidad/proceso-entero/clasificacion-camaron-entero/pendientes',
                {
                    params: data,
                }
            )
            return res.data
        },

        // Quitar
        // Getters en ventana de Salmuera
        // consultarSalmueraAuditoria({ commit }, data) {
        //     return new Promise((resolve, reject) => {
        //         axios
        //             .get('/api/auth/controlCalidad/ConsultaSalmueraAuditoria', { params: data })
        //             .then(response => {
        //                 commit('setDescongeladoSalmuera', response.data)
        //                 resolve(response)
        //             })
        //             .catch(error => {
        //                 reject(error)
        //                 console.error(error)
        //             })
        //     })
        // },
        editEmpaquePT(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/empaque/editarReportePT', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        editEmpaquePTAuditoria(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/empaque/auditoria/editarReportePT', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchRegistroEmpaqueEE({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/empaque/reporteEmpaqueEE', { params })
                    .then(response => {
                        commit('setRegistroEmpaquePT', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRegistroEmpaqueEEAuditoria({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/empaque/auditoria/reporteEmpaqueEE', { params })
                    .then(response => {
                        commit('setRegistroEmpaquePTAuditoria', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postEmpaqueEE(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/empaque/saveRegistroEmpaqueEE', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        editEmpaqueEE(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/empaque/editarReporteEE', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        editEmpaqueEEAuditoria(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/empaque/auditoria/editarReporteEE', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchRegistroEmpaqueRE({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/empaque/reporteEmpaqueRE', { params })
                    .then(response => {
                        commit('setRegistroEmpaquePT', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRegistroEmpaqueREAuditoria({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/empaque/auditoria/reporteEmpaqueRE', { params })
                    .then(response => {
                        commit('setRegistroEmpaquePTAuditoria', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postEmpaqueRE(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/empaque/saveRegistroReEt', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        editEmpaqueRE(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/empaque/editarReporteReEt', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        editEmpaqueREAuditoria(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/empaque/auditoria/editarReporteRE', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchRegistroEmpaqueFS({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/empaque/reporteEmpaqueFuSe', { params })
                    .then(response => {
                        commit('setRegistroEmpaquePT', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRegistroEmpaqueFSAuditoria({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/empaque/auditoria/reporteEmpaqueFS', { params })
                    .then(response => {
                        commit('setRegistroEmpaquePTAuditoria', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postEmpaqueFS(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/empaque/saveRegistroFuSe', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        editEmpaqueFS(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/empaque/editarReporteFuSe', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        editEmpaqueFSAuditoria(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/empaque/auditoria/editarReporteFS', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchRegistroEmpaquePT({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/empaque/reporteEmpaquePT', { params })
                    .then(response => {
                        commit('setRegistroEmpaquePT', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRegistroEmpaquePTAuditoria({ commit }, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/empaque/auditoria/reporteEmpaquePT', { params })
                    .then(response => {
                        commit('setRegistroEmpaquePTAuditoria', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        postEmpaquePT(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/empaque/saveRegistroEmpaquePT', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        modificarValorAgregado(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/ModificarValorAgregado', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        consultarReporteValorAgregadoAuditoria({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/ConsultarReporteValorAgregadoAuditoria', { params: data })
                    .then(response => {
                        commit('setReporteHidratante', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        registrarProcesoCola(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/RegistroProcesoCola', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        consultarReporteTemperaturaAuditoria(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/consultarTemperaturaAuditoria', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // producto terminado
        fetchRegistroAnalisisPT(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/regisitrarAnalisisPT', data)
                    .then(res => {
                        resolve(res)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchReporteProductoTerminado({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/reporteProductoTerminado', data)
                    .then(response => {
                        commit('setreportesProductoTerminado', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchReporteProductoTerminadoAuditoria({ commit }, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/reporteProductoTerminadoAuditoria', data)
                    .then(response => {
                        commit('setreportesProductoTerminadoAuditoria', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        editarRegistroPT(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/editarPT', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        editarRegistroPTAuditoria(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/editarPTAuditoria', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        RegistrarRecepcionGaveta(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/regitrarRecepcionGaveta', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        CargarTemperaturaBines(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/CargarTemperaturaBines', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        RegistrarControlBalanzas(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/RegistrarControlBalanzas', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        //Otros
        async registroControlBalanza(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/otros/control-balanza', data)
            return res.data.data.id
        },

        async registroChecklistInspeccionTransportePT(_a, data) {
            const res = await axios.post(
                '/api/auth/controlCalidad/otros/checklist-inspeccion-transporte-producto-terminado',
                data
            )
            return res.data.data.id
        },

        async registroSanitizacionCartonesPT(_a, data) {
            const res = await axios.post('/api/auth/controlCalidad/otros/sanitizacion-cartones-pt', data)
            return res.data.data.id
        },

        fetchReporteOtrosAuditoria(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/reporteOtrosAuditoria', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchReporteOtros(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/reporteOtros', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchModificarProcesoControlBalanzaAuditoria(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/ModificarProcesoControlBalanzaAuditoria', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchModificarProcesoControlBalanza(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/ModificarProcesoControlBalanza', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        /** Control Escurrido proceso terminado */

        fetchReporteProcesoTerminadoAuditoria(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/reporteProcesoTerminadoAuditoria', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchReporteProcesoTerminado(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/reporteProcesoTerminado', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        /*
        RegistrarControlEscurrido({ commit }, data){
            return new Promise((resolve, reject) => {
                axios
                    .post(
                        '/api/auth/controlCalidad/RegistrarControlEscurrido', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },*/

        fetchEmpaque({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/empaques')
                    .then(response => {
                        commit('setEmpaque', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        fetchMaster({ commit }) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/masters')
                    .then(response => {
                        commit('setMaster', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },

        RegistrarControlEscurrido(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/RegistrarControlEscurrido', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchRegistroPesoBrutoPT(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/RegistrarPesoBrutoPT', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        /** Imspeccion transporte producto terminado */
        RegistrarInspeccionTransporteProductoTerminado(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/RegistrarInspeccionTransporteProductoTerminado', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },

        fetchModificarInspeccionTransporteProductorTerminadoAuditoria(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/ModificarInspeccionTransporteProductorTerminadoAuditoria', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchModificarInspeccionTransporteProductorTerminado(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/ModificarInspeccionTransporteProductorTerminado', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        // Registro de Procesos
        fetchRegistroRetractiladoPT(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/RegistrarRetoactiladoPT', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchEmpaqueReEtFiltro(_a, params) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/empaque/filtro/re-et', { params })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        consultarReporteOtros(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/auth/controlCalidad/ReporteOtros', { params: data })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarReporteOtros(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/modificarReporteOtros', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        modificarReporteOtrosAuditoria(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/modificarReporteOtrosAuditoria', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        registrarControlSanitizacionCartones(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/RegistroControlSanitizacionCartones', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchGetProveedor(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/controlCalidad/getProveedor`, {
                        params: data,
                    })
                    .then(response => {
                        //commit('setProveedor', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchGetCamaronera(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/controlCalidad/getCamaronera`, {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchGetCamaronerav2(_a, data) {
            //todo: reparar mas tarde
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/v2/control-calidad/materia-prima/rc-mp-01/inp-list`, {
                        params: data,
                    })
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchGetPiscina(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/controlCalidad/getPiscina`, {
                        params: data,
                    })
                    .then(response => {
                        //commit('setProveedor', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchConsultarClasificacionEntero(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/auth/controlCalidad/proceso-entero/clasificacion-camaron-entero`, {
                        params: data,
                    })
                    .then(response => {
                        //commit('setProveedor', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchModificarClasificacionEntero(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/api/auth/controlCalidad/proceso-entero/modificacion-clasificacion-camaron-entero`, data)
                    .then(response => {
                        //commit('setProveedor', response.data)
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                        console.error(error)
                    })
            })
        },
        fetchUpdateCreateCorreccion(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/controlCalidad/modificar-correccion', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        fetchSetRevisionJefePlantaPtCongeladoFresco(_a, data) {
            return new Promise((resolve, reject) => {
                axios
                    .post('/api/auth/v2/control-calidad/prod-terminado/rc-cc-108/revisar', data)
                    .then(response => {
                        resolve(response)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
    },
}
